// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverPermissions {
	mayToggleSpeeding: boolean;

	mayToggleLeftPass: boolean;

	mayToggleRightPass: boolean;

	maySnoozeHorn: boolean;

	mayRequestClips: boolean;

	mayChangeCollisionSettings: boolean;

	maxSnoozeSeconds: number;

	$type?: string | undefined;
}
export class DriverPermissions {
	constructor(data?: IDriverPermissions) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	mayToggleSpeeding: boolean = false;

	mayToggleLeftPass: boolean = false;

	mayToggleRightPass: boolean = false;

	maySnoozeHorn: boolean = false;

	mayRequestClips: boolean = false;

	mayChangeCollisionSettings: boolean = false;

	maxSnoozeSeconds: number = 0;

	static $type: string = "CoreApi.Models.DriverPermissions, ";
	$type?: string | undefined = DriverPermissions.$type;
}

